import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getApiV2ProductsId,
  type GetProductParams,
} from '@hungryroot/rest/api/v2/products/[id]/get';

type OptionType = Pick<UseQueryOptions, 'enabled'>;

export function useProductList(
  queryParams: Omit<GetProductParams, 'productId'> & { productIds: number[] },
  options?: OptionType
) {
  return useQuery({
    queryKey: ['products', queryParams.productIds, queryParams],
    queryFn: async () => {
      const resp = await Promise.all(
        queryParams.productIds.map((id) =>
          getApiV2ProductsId({ ...queryParams, productId: id })
        )
      );

      if (resp.some((r) => r.status !== StatusCode.SuccessOK)) {
        throw resp.find((r) => r.status !== StatusCode.SuccessOK)?.data;
      }

      return resp.map((r) => r.data);
    },
    ...options,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
